import { Reveal } from "./Reveal";
import { siteConfig } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const Focus = () => {
  const { t } = useLang();
  const images = [
    siteConfig.images.focusUrban,
    siteConfig.images.focusRenovation,
    siteConfig.images.focusRental,
  ];

  return (
    <section
      id="focus"
      data-testid="focus-section"
      className="scroll-mt-24 bg-[#EAE8E3] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-6">
            {t.focus.overline}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#1A1C19] max-w-2xl">
            {t.focus.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {t.focus.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.12}>
              <article data-testid={`focus-card-${i}`} className="group">
                <div className="relative overflow-hidden aspect-[4/5]">
                  <img
                    src={images[i]}
                    alt={item.title}
                    className="h-full w-full object-cover transition-transform [transition-duration:1200ms] ease-out group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <h3 className="mt-6 font-serif text-2xl text-[#1A1C19]">
                  {item.title}
                </h3>
                <p className="mt-3 text-sm md:text-base leading-relaxed text-[#5C5C59]">
                  {item.copy}
                </p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p data-testid="focus-note" className="mt-14 text-sm text-[#5C5C59] italic">
            {t.focus.note}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
